import React from "react";
import { useSelector } from "react-redux";
import { Navigate, Outlet, useLocation } from "react-router-dom";

const ProtectedRoute = ({ requiredRoles }) => {

    const { user } = useSelector((state) => state.auth);
    const location = useLocation();

    const isAuthenticated = !!user;
    return isAuthenticated ? (
        <Outlet />
    ) : (
        <Navigate to="/login" state={{ from: location }} replace />
    );

    // const userData = localStorage.getItem('user');

    // let user = null
    // if (userData && userData !== undefined) {
    //     user = userData ? JSON.parse(userData) : null;
    // }


    // // Handle user not logged in
    // if (!user) {
    //     return <Navigate to="/login" replace />;
    // }

    // console.log(requiredRoles, user);


    // // Handle role-based access
    // if (requiredRoles && !requiredRoles.includes(user.role)) {
    //     return <Navigate to="/not-authorized" />;
    // }

    // return <Outlet />;
};

export default ProtectedRoute;